import ApplicationRecord from './ApplicationRecord';
/**
 * Home page.
 *
 *
 */
export default class GenericPage
  extends ApplicationRecord({
    /**
   * @type {Number}
   */
    ID: -1,
    /**
     * @type {String}
     */
    Path: '',
    /**
     * @type {Boolean}
     */
    ShowInMenus: false,
    /**
     * @type {String}
     */
    Title: '',
    /**
     * @type {String}
     */
    Content: '',
  }) {}



// WEBPACK FOOTER //
// ./src/models/GenericPage.js